import { Button, CircularProgress, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from "@mui/material";
import BetlistShortDto from "../models/dtos/BetlistShortDto";
import React from "react";
import { useNavigate } from "react-router-dom";
import { cancelRecalculateMatch, getBalancePaginated, getBetlistsPaginated, getMatchVarietiesWithRequests, recalculateMatch } from "../Api";
import BalanceHistoryRecordDto from "../models/dtos/BalanceHistoryRecordDto";
import MatchVarietyDto from "../models/dtos/MatchVarietyDto";
import VarietyWithRequestsDto from "../models/dtos/VarietyWithRequestsDto";
import ProviderSyncLogRecordDto from "../models/dtos/ProviderSyncLogRecordDto";

interface ProviderLogTable {
    log: ProviderSyncLogRecordDto[]
}

export default function ProviderLogTable(props: ProviderLogTable) {

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell align="left">Date</TableCell>
                    <TableCell align="left">ConstSportEventId</TableCell>
                    <TableCell align="left">SportEventId</TableCell>
                    <TableCell align="left">Type</TableCell>
                    <TableCell align="left">Raw</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {props.log.map(item => (
                    <React.Fragment>
                        <TableRow sx={{ background: '#ececec' }}>
                            <TableCell>
                                <Typography variant="subtitle1">
                                    {new Date(item.createdAt).toLocaleString()}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="subtitle1">
                                    {item.constSportEventId}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="subtitle1">
                                    {item.sportEventId}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography variant="subtitle1">
                                    {item.logType}
                                </Typography>
                            </TableCell>
                            <TableCell>
                                <div style={{ maxHeight: '200px', overflow: 'scroll' }}>
                                    <pre style={{ margin: 0 }}>
                                        {JSON.stringify(item.data, null, 2)}
                                    </pre>
                                </div>
                            </TableCell>
                        </TableRow>
                    </React.Fragment>
                ))}
            </TableBody>
        </Table>);
}